var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_557",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 557",
    transform: "translate(-179 -893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u591A\\u89D2\\u5F62_1",
    "data-name": "\\u591A\\u89D2\\u5F62 1",
    transform: "translate(179 893)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0l9,14H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 3.698524475097656 L 3.663336753845215 12 L 14.33666229248047 12 L 9 3.698524475097656 M 9 0 L 18 14 L 0 14 L 9 0 Z",
    stroke: "none",
    fill: "#172b4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.3398b1b5924a8a22e5078e77eebb2258.svg";
export { ForwardRef as ReactComponent };